import React, { useState, useEffect } from "react";
import { changeIndexToNepali, colorScale } from "../../utils";
import Api from "../../services/api";
import localMapJson from "../../assets/geoJson/province.json";
import { Line } from "rc-progress";
import GradientLabel from "../../components/GradientLabel";
import { ListGroup, ListGroupItem, Row, Col } from "reactstrap";
import ProgressBar from "../../components/ProgressBar";
import {
  Radar,
  Legend,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";
import "./style.css";
import HorizontalSteps from "../../components/HorizontalSteps";
import MinistryDetailTable from "../../components/CustomTable/MinistryDetailTable";

export default function Score() {
  const [data, setData] = useState([]);
  const [status, setStatus] = useState();
  const [tableData, setTable] = useState([]);
  const [ministryCat, setMinistryCat] = useState([]);
  const [user, setUser] = useState(
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).user
  );
  const fy = "074/75";
  const stepData = [
    {
      date: "2021/01/01",
      title: "प्रारम्भिक नतिजा तयार हुदैँ",
    },
    {
      date: "2021/01/01",
      title: "प्रारम्भिक नतिजा पेश",
    },
    {
      date: "2021/01/01",
      title: "पृष्ठपोषणका लागी पेश",
    },
    {
      date: "2021/01/01",
      title: "अनुमोदनका लागि पेश",
    },
    {
      date: "2021/01/01",
      title: "अन्तिम नतिजा सार्वजनिक",
    },
    {
      date: "2021/01/01",
      title: "गुणस्तर परिक्षण",
    },
  ];
  let search = window.location.search;
  let newS = search.slice(6, -11);
  let geoJson = localMapJson.response.filter((province) => {
    return +sessionStorage.getItem("provinceId") === province.id;
  });
  geoJson = geoJson[0];
  let localData = JSON.parse(localStorage.getItem("user"));
  const getData = async () => {
    // console.log("neWs", newS);
    let response = await Api.getDetail(
      localData.user.fiscal_year_id,
      sessionStorage.getItem("provinceId"),
      sessionStorage.getItem("m_id")
    );
    setData(response.response);
    setStatus(response.response.current_stage);
  };

  useEffect(() => {
    getData();
    // _getCategories();
    getMinistryCategories();
  }, [window.location.search]);
  const cars = new Array(data.subCategories);
  console.table(cars[0]);
  let check = cars.toString();
  var check2 = check.split(",");

  // const _getCategories = async () => {
  //   let response = await Api.getQuestions(
  //     localData.user.fiscal_year_id,
  //     sessionStorage.getItem("provinceId"),
  //     newS
  //   );
  //   // console.log(response);
  //   setTable(response.response.questions);
  //   setStatus(response.response.current_stage_id);
  // };

  const getMinistryCategories = async () => {
    let response = await Api.getMinistryQuestions(
      user && user.fiscal_year_id,
      // ? user && user.fiscal_year_id
      // : currentFiscalYear,
      sessionStorage.getItem("provinceId"),
      user.ministry_id ? user.ministry_id : sessionStorage.getItem("m_id")
    );
    setMinistryCat(response.response.questions);
    setTable(response.response.questions);
  };

  return (
    <div>
      <HorizontalSteps activeStep={status} stepData={stepData} />
      <div className="header">
        <h1 className="heading">
          {data.name}(
          {ministryCat.reduce((acc, curr) => acc + curr.obtained_marks, 0)})
        </h1>{" "}
        {/*TODO show , district name from map data*/}
        <GradientLabel />
      </div>
      <div className="content">
        <div className="row">
          <div className="col-sm-6">
            <div className="card-layout">
              <h3 className="sub-heading">विवरण</h3>
              <div className="progress-section">
                <div className="row">
                  <div className="col-md-12">
                    <ListGroup className="list-detail">
                      <ListGroupItem>
                        <h5 style={{ color: colorScale(data.score) }}>
                          प्रदेश:
                        </h5>{" "}
                        <span>{data.province}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        <h5 style={{ color: colorScale(data.score) }}>
                          मन्त्रालय:
                        </h5>{" "}
                        <span>{data.name}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        <h5 style={{ color: colorScale(data.score) }}>ईमेल:</h5>{" "}
                        <span>{data.email}</span>
                      </ListGroupItem>
                      <ListGroupItem>
                        <h5 style={{ color: colorScale(data.score) }}>
                          वेबसाइट:
                        </h5>{" "}
                        <span>{data.website}</span>
                      </ListGroupItem>
                    </ListGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="card-layout">
              <h3 className="sub-heading2">जम्मा प्राप्ताङ्क </h3>
              <div className="leaflet-container">
                {check2 &&
                  check2.map((item, i = 0) => (
                    <Row>
                      <Col sm="2">
                        <h3 className="progressbar-text">
                          {i === 0
                            ? "समग्र स्थिति"
                            : i === 1
                              ? "प्रक्रियागत स्थिति"
                              : "परिमाणात्मक स्थिति"}
                        </h3>
                      </Col>
                      <Col sm="10">
                        <div
                          style={{ marginLeft: `${check2[i]}%` }}
                          className="progress-percent"
                        >
                          {changeIndexToNepali(check2[i])}%
                        </div>
                        <Line
                          percent={check2[i]}
                          strokeWidth={1}
                          strokeColor={colorScale(check2[i])}
                        />
                        <span key={i++}></span>
                      </Col>
                    </Row>
                  ))}
                <Row>
                  <Col sm="2">
                    <h3 className="progressbar-text">औसत:</h3>
                  </Col>
                  <Col sm="10">
                    {console.log("data", data)}
                    <div
                      style={{
                        marginLeft: `${data &&
                          data.answer &&
                          data.answer.average_score}%`,
                      }}
                      className="progress-percent"
                    >
                      {changeIndexToNepali(
                        data && data.answer && data.answer.average_score
                      )}
                      %
                    </div>
                    <Line
                      percent={data && data.answer && data.answer.average_score}
                      strokeWidth={1}
                      strokeColor={colorScale(
                        data && data.answer && data.answer.average_score
                      )}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <div className="chart-section">
          <Row>
            <Col sm="4">
              <div className="cat-list card-layout">
                <h3 className="sub-heading"> मूल्याङ्कन विषयक्षेत्रहरु </h3>
                <div className="main-list">
                  <span className="dash-cat-name-title"></span>
                  {/* <span className='dash-cat-rank-title'>बरीयतक्रम</span> */}
                  <span className="dash-cat-score-title">स्कोर प्रतिशत</span>
                </div>
                {tableData &&
                  tableData.map((item, catIndex) => {
                    const isImage =
                      item.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;
                    return (
                      <div className="main-list">
                        <span className="dash-cat-name">
                          <img
                            src={
                              // isImage
                              //   ? item.image
                              //   : require(`../../assets/images/${catIndex +
                              //       1}.svg`)
                              item.image

                            }
                            className="cat-icon"
                            alt="cat-icon"
                          />
                          {item.name}
                        </span>
                        {/* <span className='dash-cat-rank'>{changeIndexToNepali(category.rank)}</span> */}
                        <ProgressBar
                          bgcolor={colorScale(item.marks_percentage)}
                          progress={item.marks_percentage}
                          height={10}
                        />
                      </div>
                    );
                  })}
              </div>
            </Col>
            <Col sm="8">
              <div className="card-layout">
                <RadarChart
                  outerRadius={150}
                  width={600}
                  height={400}
                  data={tableData}
                >
                  <PolarGrid />
                  <PolarAngleAxis dataKey="name" />
                  <PolarRadiusAxis angle={90} domain={[0, 100]} />
                  <Radar
                    name="प्राप्ताङ्क"
                    dataKey="marks_percentage"
                    stroke="#0ba711"
                    fill="transparent"
                    fillOpacity={0.6}
                  />
                  <Legend />
                </RadarChart>
              </div>
            </Col>
          </Row>
        </div>
        {/* <div className="chart-section">
          <ScoreTable comments={tableData} />
        </div> */}
        <div className="chart-section">
          <MinistryDetailTable
            comments={ministryCat}
            title={"मन्त्रालयगत वित्तीय सुशासन लेखाजोखा तालिका"}
          />
        </div>
      </div>
    </div>
  );
}
